<template>
  <div id="serviceCardContainer">
    <v-container>
      <v-row>
        <v-col>
          <h1>{{ englishLang.allServices }}</h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field
            :label="englishLang.allServicesSearchPlaceholder"
            outlined
            rounded
            autocomplete="off"
            dense
            v-model="searchText"
            append-icon="mdi-magnify"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row wrap>
        <v-col
          cols="12"
          sm="6"
          v-for="card in this.filteredCardData"
          :key="card.id"
        >
          <v-card class="serviceCard" style="min-height: 50vh">
            <v-card-title class="allServiceCardHeader">
              <v-icon dark large class="mr-3">
                {{ card.icon }}
              </v-icon>
              {{ englishLang[card.header] }}
            </v-card-title>
            <v-list shaped :aria-label="englishLang[card.header]">
              <v-list-item v-for="link in card.links" :key="link.id">
                <v-list-item-content>
                  <router-link v-if="link.url === '/login'" :to="link.url">{{
                    englishLang[link.name]
                  }}</router-link>
                  <router-link
                    v-else-if="link.url === '/salvage'"
                    :to="link.url"
                    >{{ englishLang[link.name] }}</router-link
                  >
                  <a v-else :href="link.url">{{ englishLang[link.name] }}</a>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import EnglishLang from "../../../public/languages/English.json";
export default {
  name: "AllServices",
  data: function() {
    return {
      searchText: "",
      AllServicesCards: [],
      englishLang: EnglishLang
    };
  },
  computed: {
    filteredCardData() {
      const matchingCards = [];
      this.AllServicesCards.some(card => {
        if (card.header.toLowerCase().includes(this.searchText.toLowerCase())) {
          matchingCards.push(card);
        } else {
          card.links.some(link => {
            if (
              link.name.toLowerCase().includes(this.searchText.toLowerCase())
            ) {
              matchingCards.push(card);
              return true;
            }
          });
        }
      });

      return matchingCards;
    }
  },
  methods: {
    readInCards: function() {
      axios.get("./landing-page/AllServices.json").then(response => {
        this.AllServicesCards = response.data;
      });
    }
  },
  mounted: function() {
    this.readInCards();
  }
};
</script>

<style scoped lang="scss">
.serviceCard {
  margin-left: 10px;
  margin-right: 10px;
}
.allServiceCardHeader {
  color: white;
  background-color: #1b365d;
  word-break: break-word !important;
}
.allServiceCardLinkTitle {
  white-space: pre-wrap !important;
}
@media (min-width: 1264px) {
  .container {
    max-width: 1100px !important;
    min-width: 1100px;
  }
}
</style>
